import { z } from "zod/v3";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import type { RegisteredUser } from "@workspace/profile";

import { LoginForm } from "@/components/login-form";
import { PageLoadingFull } from "@/components/page-loading";

const fallback = "/" as const;

export const Route = createFileRoute("/login/")({
	validateSearch: zodValidator(
		z.object({
			redirect: z.string().optional().catch(""),
			identifier: z.string().optional(),
		}),
	),
	component: LoginComponent,
	pendingComponent: PageLoadingFull,
});

function LoginComponent() {
	const { auth } = Route.useRouteContext();
	const navigate = Route.useNavigate();
	const search = Route.useSearch();

	const router = useRouter();

	const handleLoginSuccess = async (
		profile: RegisteredUser,
		provider: string,
		token: string,
	) => {
		await auth.login(profile, provider, token);

		await router.invalidate();

		await navigate({ to: search.redirect || fallback, replace: true });
	};

	return (
		<div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
			<div className="w-full max-w-sm">
				<LoginForm
					onLoginSuccess={handleLoginSuccess}
					redirect={search.redirect || fallback}
					email={search.identifier || ""}
				/>
			</div>
		</div>
	);
}
